export const HerMajestysTheatre = {
  basketNote: {},
  colors: {
    venueLogoBackgroundColor: '#d688ac'
  },
  themeVenueLogo: 'her_majestys_sw_icon.png',
  themeVenueName: 'Her Majestys Theatre',
  themeVenueAddress: '57 Haymarket, London SW1Y 4QL'
}
